module.exports = __webpack_public_path__ + "static/media/hail.799d518e.ico";